// extracted by mini-css-extract-plugin
export default {"shareItemContentWrapper":"Ylk0c","shareItemContent":"SxWcG","name":"DSFjP","wrappedName":"IgKqW","wrapText":"V0wIl"};